export default __webpack_public_path__ + "static/media/defaultUser.a6143582.png";